import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import qualityStore from '../stores/QualityStore';
import Message from '../../Common/components/Message';
import messageStore from '../../Common/stores/messageStore';

@observer
export default class ConfirmationScreen extends Component {

  componentDidMount = () => {
    const { history } = this.props;
    if (!qualityStore.confirmationId) {
      history.push('/')
    }
  }

  componentWillUnmount = () => {
    const { history } = this.props;
    if (history.action === 'POP') {
      history.push('/')
      qualityStore.disablePages();
      qualityStore.clearIncidentForm();
    }
  }

  render() {
    const { submitSuccess, confirmationId, stateCode } = qualityStore;

    return (
      <Card>
        <CardBody className="p-40">
          <div className="border-form">
            {submitSuccess ?
              <>
                <div className="center-text">
                  <i className="icon icon-ok-circle check-icon" />
                </div>
                <h2 className="center-text confirmationTitle">Incident Submitted</h2>
                <p className="center-text">
                  Thank you for completing the Quality of Care Report.
                </p>
                <div className="spacer" />
                <p className="center-text">
                  Confirmation: <b>{confirmationId}</b>
                </p>
                <div className="spacer" />
                <p className="center-text">
                  If you have questions regarding this form or need to update a form you’ve previously submitted,
                  please contact our Quality Management Department at
                  {
                    stateCode === 'NE' ?
                      <a href="mailto: QualityManagementPQOCTeam@anthem.com"> QualityManagementPQOCTeam@anthem.com</a>
                      :
                      <>
                        {
                          stateCode === 'MO' ?
                            <a href="mailto: MO.HPGA@anthem.com"> MO.HPGA@anthem.com</a>
                            :
                            <a href="mailto: Qualityofcare@healthybluenc.com"> Qualityofcare@healthybluenc.com</a>
                        }
                      </>
                  }
                  .
                </p>
              </>
              :
              <Message messageStore={messageStore} />
            }
          </div>
        </CardBody>
      </Card>
    );
  }
}

ConfirmationScreen.propTypes = {
  history: PropTypes.object
};